import React, { useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link } from "react-router-dom";
import {
  Flex,
  Image,
  PaginationProps,
  Table,
  TableColumnsType,
  Tabs,
  Input,
  Button,
  notification,
  DatePicker,
} from "antd";
import {
  Home2,
  SearchZoomIn1,
  DocumentDownload,
  Calendar,
} from "iconsax-react";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import type { TabsProps } from "antd";
import "./style.scss";
import { mixPostV1 } from "../../services/mixin";
import * as XLSX from "xlsx";
import DeleteModal from "../../components/Modal/DeleteModal";

const numberFormat = (number: any) => {
  let result;
  if (typeof number === "number") {
    result = new Intl.NumberFormat().format(number);
  } else {
    result = number;
  }
  return result;
};

interface DataType {
  key: React.Key;
  award_date: string;
  id: number;
  label_id: number;
  name: string;
}

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const ReportGame: React.FC = () => {
  const storeTypeId = localStorage.getItem("storeTypeId");
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState<string>("luckyGame");
  const [exportLoading, setExportLoading] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedId, setSelectedId] = useState<number>();
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    searchKey: string;
    date_search: string;
    x: number;
    tab: string;
  }>({
    limit: 10,
    page_number: 1,
    searchKey: "",
    date_search: "",
    x: 0,
    tab: "luckyGame",
  });

  const columns: TableColumnsType<DataType> = [
    {
      title: "",
      key: "actions",
      fixed: "left",
      className: "actions-sticky width-del",
      render: (text, record) => (
        <div className="text-center">
          <Button
            icon={<DeleteOutlined />}
            className="rs-button delete"
            onClick={() => {
              setSelectedId(record.id);
              setShowDeletePopup(true);
            }}
          />
        </div>
      ),
    },
    {
      title: "Time",
      dataIndex: "award_date",
      key: "award_date",
    },
    {
      title: "App ID",
      dataIndex: "label_id",
      key: "label_id",
      hidden: currentTab !== "luckyGame",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Phone number",
      dataIndex: "phone_number",
      key: "phone_number",
      hidden: currentTab !== "luckyGame",
    },
  ];

  useEffect(() => {
    if (Number(storeTypeId) !== 4) getListLuckygame();
  }, []);

  useEffect(() => {
    if (params.x !== 0) {
      if (params.tab === "luckyGame") {
        getListLuckygame();
      }

      if (params.tab === "randomGame") {
        getListRandomGame();
      }
    }
  }, [params.x]);

  // TABS
  const tabs: TabsProps["items"] = [
    {
      key: "luckyGame",
      label: "Lucky Game",
    },
    {
      key: "randomGame",
      label: "Random Game",
    },
  ];
  const onTabChange = (key: string) => {
    setCurrentTab(key);

    setParams({ ...params, page_number: 1, x: params.x + 1, tab: key });
  };
  // END TABS

  // GET CASH OUT WITH PROOF
  const getListLuckygame = async () => {
    setLoading(true);

    try {
      const param = {
        page_number: params.page_number,
        limit: params.limit,
      } as any;
      if (params.searchKey) {
        param.searchKey = params.searchKey;
      }
      if (params.date_search) {
        param.date_search = params.date_search;
      }
      const res = await mixPostV1("/api/webAdmin/greportLuckyGame.php", param);

      if (res.status === 1) {
        setLoading(false);
        // const result: any = [];
        // res.data.map((item: any) =>
        //   result.push({
        //     ...item,
        //     key: item.id,
        //     time: item.timecashout,
        //     cashOut: item.match_amount,
        //     actualCashOut: 0,
        //     machine: item.machine_number,
        //     photo: item.photo_url,
        //   })
        // );
        const total = res.total;
        setItems({
          list: res.data,
          total,
        });
      }
    } catch (error) {}
  };
  // END GET CASH OUT WITH PROOF

  // GET CASH OUT WITHOUT PROOF
  const getListRandomGame = async () => {
    setLoading(true);

    try {
      const param = {
        page_number: params.page_number,
        limit: params.limit,
      } as any;
      if (params.searchKey) {
        param.searchKey = params.searchKey;
      }
      if (params.date_search) {
        param.date_search = params.date_search;
      }
      const res = await mixPostV1("/api/webAdmin/greportRandomGame.php", param);

      if (res.status === 1) {
        setLoading(false);
        // const result: any = [];
        // res.data.map((item: any) =>
        //   result.push({
        //     ...item,
        //     key: item.id,
        //     time: item.timecashout,
        //     cashOut: item.match_amount,
        //     actualCashOut: item.amount_machine,
        //     machine: item.machine_number,
        //     photo: item.photo_url,
        //   })
        // );
        const total = res.total;
        setItems({
          list: res.data,
          total,
        });
      }
    } catch (error) {}
  };
  // END GET CASH OUT WITHOUT PROOF

  // END GET HISTORY PAY BONUS CUSTOMER

  // TABLE
  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
      x: params.x + 1,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
      x: params.x + 1,
    });
  };
  // TABLE

  const getItemsByExcel = async () => {
    setExportLoading(true);
    const customParams = {
      ...params,
      page_number: 1,
      limit: 10000,
    };

    let api = "/api/webAdmin/greportLuckyGame.php";

    if (currentTab === "randomGame") {
      api = "/api/webAdmin/greportRandomGame.php";
    }

    try {
      const res = await mixPostV1(api, customParams);

      if (res.status) {
        if (res.data.length > 0) {
          formattedDataExcel(res.data);
          setExportLoading(false);
        } else {
          setExportLoading(false);
          openNotification("error", "There is no data to export!");
        }
      } else {
        setExportLoading(false);
        openNotification("error", "Oops, something went wrong!");
      }
    } catch (error) {
      setExportLoading(false);
      openNotification("error", "Oops, something went wrong!");
    }
  };
  const formattedDataExcel = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        Time: item.timecashout,
        name: item.name,
      };
    });
    exportExcel(formattedData, "Report Game");
  };
  const exportExcel = (
    convertData: any,
    nameExcel = "Report Game"
  ): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${nameExcel}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false; // Export failed
    }
  };
  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "error" = "success",
    message = "Level updated!"
  ) => {
    api[type]({
      message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  return (
    <>
      {contextHolder}
      <Layout contentClassName="staff-manage-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Report" },
            { title: "Game" },
          ]}
          title="Report Game"
          description=""
        />
        {storeTypeId !== "4" ? (
          <>
            <Tabs
              defaultActiveKey={currentTab}
              items={tabs}
              className="rs-tabs rs-tabs--no-tab-content"
              onChange={onTabChange}
            />
            <div className="table-filter-block v01">
              <div className="col left-box">
                <Input
                  placeholder="Search by name"
                  prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
                  className="rs-input w-349 grid-area-search"
                  allowClear
                  onChange={(e: any) => {
                    setParams({
                      ...params,
                      page_number: 1,
                      searchKey: e.target.value,
                      x: params.x + 1,
                    });
                  }}
                />
                <DatePicker
                  placeholder="Select date"
                  className="rs-date-picker"
                  popupClassName="rs-date-picker-dropdown"
                  suffixIcon={<Calendar size={18} variant="Bulk" />}
                  onChange={(_, dateStr: any) => {
                    setParams({
                      ...params,
                      page_number: 1,
                      date_search: dateStr,
                      x: params.x + 1,
                    });
                  }}
                />
              </div>
              <Button
                icon={<DocumentDownload size={20} variant="Bulk" />}
                className="rs-button grid-area-export"
                loading={exportLoading}
                onClick={getItemsByExcel}
              >
                Export
              </Button>
            </div>
            <Table
              columns={columns}
              dataSource={items.list}
              className="rs-table text-nowrap t-table-member"
              scroll={{
                x: true,
              }}
              loading={loading}
              showSorterTooltip={false}
              tableLayout="fixed"
              pagination={{
                total: items.total,
                pageSize: params.limit,
                position: ["bottomCenter"],
                showSizeChanger: true,
                showTitle: false,
                current: params.page_number,
                itemRender: customPrevNext,
                onChange: (e) => onPageChange(e),
              }}
              onChange={onTableChange}
            />
          </>
        ) : (
          <>
            <div className="game-not-started-screen">
              {/* <img src="/images/game.png" alt="Game not started" /> */}
              <svg
                width="400"
                height="400"
                viewBox="0 0 120 120"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {" "}
                <path
                  d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z"
                  fill="#262626"
                />{" "}
                <path
                  d="M96 120H24V42.4C27.3936 42.3962 30.6471 41.0464 33.0468 38.6468C35.4464 36.2471 36.7962 32.9936 36.8 29.6H83.2C83.1964 31.2811 83.5262 32.9462 84.1704 34.499C84.8146 36.0518 85.7603 37.4615 86.9528 38.6464C88.1377 39.8392 89.5474 40.7853 91.1004 41.4296C92.6533 42.0739 94.3187 42.4037 96 42.4V120Z"
                  fill="white"
                />{" "}
                <path
                  d="M59.9994 81.5999C70.6032 81.5999 79.1994 73.0038 79.1994 62.3999C79.1994 51.796 70.6032 43.1999 59.9994 43.1999C49.3955 43.1999 40.7994 51.796 40.7994 62.3999C40.7994 73.0038 49.3955 81.5999 59.9994 81.5999Z"
                  fill="#98A2B3"
                />{" "}
                <path
                  d="M66.7875 71.4509L59.9993 64.6627L53.211 71.4509L50.9483 69.1881L57.7365 62.3999L50.9483 55.6117L53.211 53.349L59.9993 60.1372L66.7875 53.349L69.0502 55.6117L62.262 62.3999L69.0502 69.1881L66.7875 71.4509Z"
                  fill="white"
                />{" "}
                <path
                  d="M70.3994 86.4H49.5994C48.2739 86.4 47.1994 87.4745 47.1994 88.8C47.1994 90.1255 48.2739 91.2 49.5994 91.2H70.3994C71.7249 91.2 72.7994 90.1255 72.7994 88.8C72.7994 87.4745 71.7249 86.4 70.3994 86.4Z"
                  fill="#EAECF0"
                />{" "}
                <path
                  d="M77.5996 95.9997H42.3996C41.0742 95.9997 39.9996 97.0742 39.9996 98.3997C39.9996 99.7252 41.0742 100.8 42.3996 100.8H77.5996C78.9251 100.8 79.9996 99.7252 79.9996 98.3997C79.9996 97.0742 78.9251 95.9997 77.5996 95.9997Z"
                  fill="#EAECF0"
                />{" "}
              </svg>
              <div className="message">
                Your current plan does not include this feature.
              </div>
            </div>
          </>
        )}
      </Layout>
      <DeleteModal
        isShow={showDeletePopup}
        content="Are you sure you want to delete this item?"
        message="Confirm deleted!"
        deleteApi={
          params.tab === "luckyGame"
            ? "/api/webAdmin/deleteLuckyGame.php"
            : "/api/webAdmin/deleteRandomGame.php"
        }
        deleteId={selectedId}
        deleteKey="id"
        onModalClose={() => setShowDeletePopup(false)}
        onModalSubmit={() => {
          if (params.tab === "luckyGame") {
            getListLuckygame();
          }

          if (params.tab === "randomGame") {
            getListRandomGame();
          }
          setShowDeletePopup(false);
        }}
      />
    </>
  );
};

export default ReportGame;

